import { StateCreator } from 'zustand'
import { MOCK_PROJECT_DATA } from 'Data/Project'

export interface IProjectSlice {
  projects: any[]
  project: any
  setProjects: (projects: any[]) => void
  setProject: (project: any) => void
  getAll: () => Promise<void>
  getOne: (id: string) => Promise<void>
}

export const createProjectSlice: StateCreator<IProjectSlice, [], []> = (set, get) => ({
  projects: [],
  project: {},
  setProjects: projects => set({ projects }),
  setProject: project => set({ project }),
  getAll: async () => {
    set({ projects: MOCK_PROJECT_DATA })
  },
  getOne: async (id: string) => {
    set({ project: MOCK_PROJECT_DATA[0] })
  },
})
